import { createRouterSelector } from '@atlassian/react-resource-router/src/controllers/router-store';
import { expValEquals } from '@atlassian/jira-feature-experiments';
import { fg } from '@atlassian/jira-feature-gating';
import type { RouteName } from '@atlassian/jira-route-name-types/src/RouteName.tsx';

// Controls whether specific routes can see the Rovo button
// Add your routes here to control it using an experiment or feature gate
// Returning false will disable the Rovo button
const blacklistedJiraRoutes: Partial<Record<RouteName, () => boolean>> = {
	issue: () => expValEquals('jira_ai_rovo_button', 'treatment', 'A', 'A'), // hides rovo button when experiment is turned on
};

export const useIsRovoAvailableForRoute = createRouterSelector((state) => {
	const routeName = state.route.name;

	if (blacklistedJiraRoutes[routeName]) {
		return blacklistedJiraRoutes[routeName]() ?? false;
	}

	// Controls whether all routes can see the Rovo button
	return fg('global_rovo_button_in_jira');
});

// rolling it out should be true
